<app-modal-title
  [title]="model.name"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<!-- smsText -->
<div
  class="list-group-item tw-border tw-border-gray-100 dark:tw-border-dark-100 dark:tw-bg-dark-300 tw-rounded-md tw-m-4 tw-flex tw-justify-start flex-column tw-py-4 tw-my-2 tw-h-40"
>
  <div
    class="tw-flex tw-justify-start tw-items-center border-bottom dark:tw-border-dark-200 tw-pb-2 dark:tw-text-gray-300"
  >
    <i class="mdi mdi-message-cog tw-ml-2 tw-mb-1 mdi-20px"></i>
    <span class="tw-font-medium">{{ "common.smsText" | translate }} </span>
  </div>
  <div
    class="tw-pt-5 tw-text-gray-600 dark:tw-text-gray-200 sms-text font-vazir-ui"
    copyToClipboard
  >
    {{ smsText }}
  </div>
</div>

<!--voiceMessagePath-->
<app-audio-controller
  class="tw-mb-3"
  *ngIf="model?.path"
  [smallSize]="true"
  [audioSrc]="model?.path | addApiUrlBeforePath"
></app-audio-controller>
